import { render, staticRenderFns } from "./formsub.vue?vue&type=template&id=70733028&scoped=true"
import script from "./formsub.vue?vue&type=script&lang=js"
export * from "./formsub.vue?vue&type=script&lang=js"
import style0 from "./formsub.vue?vue&type=style&index=0&id=70733028&prod&lang=css"
import style1 from "./formsub.vue?vue&type=style&index=1&id=70733028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70733028",
  null
  
)

export default component.exports